module.exports = __webpack_public_path__ + "img/person-circle.dd0df253.svg";